export const SHOW_FILTERS = "Show All Filters";

export const CLEAR_FILTERS = "Clear All Filters";

export const CLINICAL_DATA = "Clinical Data";
